/*
 * 监听 redux store：group 切换或 user 切换时，立即清掉 cpu token。
 * 模块顶层 import 一次就 install，无需手动调。
 */

import { store } from '../../../app/store'
import { invalidateToken } from './tokenService'
import { invalidateSkillCache } from '../components/blocks/skillCache'

let lastGroupId = ''
let lastUserId = ''
let installed = false

function readKeys(): { groupId: string; userId: string } {
  try {
    const state: any = store.getState()
    const userId = String(state?.main?.user?.user_id || '')
    const groupId = String(state?.group?.groupId || '')
    return { userId, groupId }
  } catch {
    return { userId: '', groupId: '' }
  }
}

export function installGroupWatcher(): void {
  if (installed) return
  installed = true
  // 先初始化一次
  const init = readKeys()
  lastGroupId = init.groupId
  lastUserId = init.userId
  store.subscribe(() => {
    const { groupId, userId } = readKeys()
    if (
      (groupId && groupId !== lastGroupId) ||
      (userId && userId !== lastUserId)
    ) {
      lastGroupId = groupId
      lastUserId = userId
      invalidateToken()
      invalidateSkillCache()
    } else if (!userId && lastUserId) {
      // 登出
      lastUserId = ''
      lastGroupId = ''
      invalidateToken()
      invalidateSkillCache()
    }
  })
}
